import { getState } from '@nile/components/src/Managers/StateManager';
import { useGlobalChatStore } from '@nile/mangifera/src/StoreManager/store/GlobalChatStore';
import React from 'react';

export const useGlobalChatHook = () => {
  const tabs = useGlobalChatStore((state) => state.tabs);
  const activeChat = useGlobalChatStore((state) => state.activeChat);

  const getGlobalConversations = () => {
    return tabs;
  };

  return {
    getGlobalConversations,
    activeChat
  };
};

export const getGlobalConversations = () => {
  const globalState =
    getState('globalState')?.['globalConversation.tabs'] || [];
  return globalState;
};

const GlobalChatHook = () => {
  const tabs = useGlobalChatStore((state) => state.tabs);
  const activeChat = useGlobalChatStore((state) => state.activeChat);

  const addTabFn = useGlobalChatStore((state) => state.addTab);

  const updateTabFn = useGlobalChatStore((state) => state.updateTab);

  const removeTabFn = useGlobalChatStore((state) => state.removeTab);

  const updateTabPropertyFn = useGlobalChatStore(
    (state) => state.updateTabProperty
  );

  const toggleActiveChatFn = useGlobalChatStore(
    (state) => state.toggleActiveChat
  );

  // Get update function from the store

  const addTabs = React.useCallback(
    (params) => {
      addTabFn(params);
    },
    [addTabFn]
  );

  const removeChat = React.useCallback(
    (chatId, params) => {
      removeTabFn(chatId, params);
    },
    [removeTabFn]
  );

  const updateTab = React.useCallback(
    (updatedTab) => {
      updateTabFn(updatedTab);
    },
    [updateTabFn]
  );

  // Memoize the function to prevent unnecessary re-renders
  const updateTabProperty = React.useCallback(
    (tabId, property, propertyData) => {
      updateTabPropertyFn(tabId, property, propertyData);
    },
    [updateTabPropertyFn]
  );

  const toggleActiveChat = React.useCallback(
    (id) => {
      toggleActiveChatFn(id);
    },
    [toggleActiveChatFn]
  );

  // Don't expose setTabs as it can be updated without matching Id
  // Instead of exposing setTab. Expose updateTab.
  // this way the developers cannot mutate global chat tabs directly.
  // Instead we should use addTabs, removeChat and updateTab and updateTabProperty to make any changes
  return {
    tabs,
    updateTab,
    addTabs,
    activeChat,
    removeChat,
    updateTabProperty,
    toggleActiveChat
  };
};

export default GlobalChatHook;
